/**
 * Resolves stored paths (/uploads/...) to full URLs against the API host.
 * Set REACT_APP_API_URL (e.g. https://yourdomain.com/api) in production.
 * Leaves http(s) and legacy URLs unchanged.
 */
const apiBaseUrl = (process.env.REACT_APP_API_URL || "").trim();
const assetBaseUrl =
  (process.env.REACT_APP_SOCKET_URL || "").trim() ||
  (apiBaseUrl ? apiBaseUrl.replace(/\/api\/?$/, "") : "");

export const getAssetUrl = (pathOrUrl) => {
  if (!pathOrUrl) return "";
  const s = String(pathOrUrl);
  if (s.startsWith("http://") || s.startsWith("https://") || s.startsWith("data:")) {
    return s;
  }
  const p = s.startsWith("/") ? s : `/${s}`;
  return assetBaseUrl ? `${assetBaseUrl}${p}` : p;
};
